import { graphql } from '../../gql';

export const GET_MANAGER = graphql(`
  query E2nApiGetManager {
    manager {
      ... on Manager {
        id
        vorname
        nachname
        email
      }
      ... on ManagerError {
        message
      }
    }
  }
`);
